import { BaseApi } from './base.api.js';

export class WorkflowTemplateApi extends BaseApi {
    constructor(client) {
        super(client, '/workflow-templates');
    }

    async validate(payload) {
        const response = await this.client.post(`${this.basePath}/validate`, payload || {});
        return response.data;
    }

    async getPayloadShape(params = {}) {
        const response = await this.client.get(`${this.basePath}/payload-shape`, { params });
        return response.data;
    }

    async publish(id) {
        const response = await this.client.post(`${this.basePath}/${id}/publish`, {});
        return response.data;
    }

    async cloneToNewVersion(id, payload) {
        const response = await this.client.post(`${this.basePath}/${id}/clone`, payload || {});
        return response.data;
    }
}
